export const STREAMING_SERVICES = [
  "spotify",
  "youtube",
  "appleMusic",
  "soundCloud",
] as const;

export type StreamingService = (typeof STREAMING_SERVICES)[number];
